export default function Logo({ className = '' }: { className?: string }) {
  return (
    <svg
      className={`h-full text-fg ${className}`}
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 439.6 191.3'
    >
      <path d='M8.9,144.6V46.2H38l32.6,66.1h1l32.7-66.1h29v98.4h-22.9V78.8h-1.3l-30,60.2H62.7L32.6,78.8h-1.3v65.8H8.9L8.9,144.6z' />
      <path d='M162.4,144.6V46.2h24.7v98.4H162.4L162.4,144.6z' />
      <path d='M406.6,144.6v-41.1h-53.2v41.1h-24.7V46.2h24.7v39.7h53.2V46.2h24.7v98.4H406.6L406.6,144.6z' />
      <g>
        <path
          d='M341.5,137.1h-45.9v-1.5c0-2.4-0.6-4.6-1.8-6.6c-1.2-2.1-3-3.8-5.7-5.5c-2.5-1.6-5.9-3.1-10.7-4.5
			c-4.8-1.4-10.3-2.6-16-3.7l-26.8-4.8c-38-6.7-57.2-23.7-57.2-50.6c0-8.5,1.9-16,5.8-22.7c4-6.9,9.5-12.8,16.4-17.5
			c7.2-4.9,15.7-8.6,25.4-11.1c9.9-2.6,20.9-3.8,32.8-3.8c11.2,0,21.9,1.3,31.6,3.8c9.9,2.7,18.1,6.3,25.1,10.9
			c7.1,4.7,12.7,10.4,16.8,16.8c4.2,6.7,6.3,13.8,6.6,21.6l0.1,1.6h-43.4l-0.2-1.3c-0.5-3.1-1.7-6-3.6-8.6c-2-2.6-4.6-4.9-7.7-6.8
			c-3-1.8-6.8-3.3-11.2-4.4c-4.7-1-9.3-1.6-14.1-1.6c-5.3,0-10.1,0.5-14.4,1.5c-4.3,1-7.8,2.3-10.9,4.1c-3,1.8-5.3,3.9-6.8,6.3
			c-1.6,2.3-2.4,5-2.4,8c0,4.8,2.3,8.6,7.2,11.5c4.9,3.1,13.2,5.7,25.5,7.9l24.9,4.4c10.9,2,19.8,4.3,27.1,7.1
			c7.6,2.9,14,6.4,18.8,10.5c5,4.2,8.6,8.9,11,14.4c2.4,5.4,3.5,11.4,3.5,18.4c0,0.5,0,1.1,0,1.6c0,1,0,2,0,3.1L341.5,137.1z
			 M298.5,134.1h39.8c0-0.6,0-1.2,0-1.8c0-0.5,0-1,0-1.5c0-6.6-1.1-12.2-3.3-17.2c-2.2-5-5.5-9.4-10.2-13.3c-4.6-3.8-10.6-7.2-18-9.9
			c-7-2.7-16-5-26.5-6.9L255.5,79c-12.7-2.3-21.4-5-26.5-8.3c-5.7-3.4-8.6-8.2-8.6-14.1c0-3.7,1-6.9,2.9-9.7c1.8-2.8,4.3-5.2,7.8-7.2
			c3.3-2,7.2-3.4,11.7-4.5c4.5-1,9.5-1.5,15-1.5c5,0,9.9,0.5,14.8,1.6c4.8,1.2,8.7,2.8,12.1,4.8c3.4,2.1,6.3,4.6,8.5,7.6
			c2,2.6,3.3,5.6,4,8.7h37.7c-0.5-6.7-2.5-12.8-6.1-18.6c-3.9-6.1-9.2-11.5-16-15.9C306,17.5,298,14,288.5,11.4
			c-9.4-2.5-19.8-3.7-30.8-3.7c-11.6,0-22.4,1.3-32,3.8c-9.3,2.4-17.5,6-24.4,10.7c-6.6,4.5-11.6,9.9-15.4,16.5
			c-3.6,6.3-5.4,13.3-5.4,21.3c0,25.5,17.9,41.1,54.8,47.6l26.8,4.8c5.8,1,11.5,2.3,16.4,3.7c5,1.6,8.7,3.1,11.4,4.9
			c3.2,2,5.3,4,6.7,6.5C297.6,129.5,298.3,131.7,298.5,134.1z'
        />
        <path d='M338.2,156.9v25h-39.5v-25H338.2 M295.6,153.8v30.4v0.7h45.5v-31h-0.2h-45.3V153.8L295.6,153.8z' />
      </g>
    </svg>
  );
}
